module.exports = __webpack_public_path__ + "img/major-prize.6acd7faf.webp";